/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *  ╔═○─┐ emotive
 *    ●●  ENGINE - Step Right Gesture
 *  └─○═╝
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *
 * Quick weight shift to the right (1 beat)
 */

import { createStepGesture } from './danceSteps.js';

export default createStepGesture('right');
